import Request from '@/utils/request';

export default async () => {
  const response = await Request.get('/variables');

  // Transform the array of objects by flattening the properties.
  return response.data.VARIABLES.map((val) => {
    const key = Object.keys(val)[0];  // get
    const obj = val[key];
    obj.name = key;
    return obj;
  });
};



// WEBPACK FOOTER //
// ./src/api/get-station-variables.js